var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.isShowRouter)?_c('div',{staticStyle:{"height":"100%"}},[(_vm.shouldKeepAlive)?_c('keep-alive',{attrs:{"include":_vm.keepAliveList}},[_c('router-view')],1):_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }